export default "assets/images/icons/news-87a9617e.svg";